"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentPropItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
/**
 * mm-meta-item으로 name/type을 표시합니다.
 * mm-component-props 안에서만 사용합니다.
 */
let ComponentPropItem = class ComponentPropItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.type = '';
        this.optional = false;
    }
    render() {
        return (0, lit_1.html) `
      <mm-meta-item layout="stacked" label=${this.formatLabel()} value=${this.type}></mm-meta-item>
    `;
    }
    formatLabel() {
        if (this.kind === 'event')
            return `@${this.name}`;
        return `${this.name}${this.optional ? '?' : ''}`;
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentPropItem.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentPropItem.prototype, "type", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentPropItem.prototype, "kind", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], ComponentPropItem.prototype, "optional", void 0);
ComponentPropItem = __decorate([
    (0, decorators_js_1.customElement)('mm-component-prop-item')
], ComponentPropItem);
exports.ComponentPropItem = ComponentPropItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LXByb3AtaXRlbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbXBvbmVudC1wcm9wLWl0ZW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUEyRDtBQUUzRCwrQkFBNEI7QUFFNUI7OztHQUdHO0FBRUksSUFBTSxpQkFBaUIsR0FBdkIsTUFBTSxpQkFBa0IsU0FBUSxnQkFBVTtJQUExQzs7UUFDdUIsU0FBSSxHQUFHLEVBQUUsQ0FBQTtRQUNULFNBQUksR0FBRyxFQUFFLENBQUE7UUFFUixhQUFRLEdBQUcsS0FBSyxDQUFBO0lBYS9DLENBQUM7SUFYQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs2Q0FDOEIsSUFBSSxDQUFDLFdBQVcsRUFBRSxVQUFVLElBQUksQ0FBQyxJQUFJO0tBQzdFLENBQUE7SUFDSCxDQUFDO0lBRU8sV0FBVztRQUNqQixJQUFJLElBQUksQ0FBQyxJQUFJLEtBQUssT0FBTztZQUFFLE9BQU8sSUFBSSxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUE7UUFFakQsT0FBTyxHQUFHLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQTtJQUNsRCxDQUFDO0NBQ0YsQ0FBQTtBQWhCNkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOytDQUFVO0FBQ1Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOytDQUFVO0FBQ1Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOytDQUFlO0FBQ2I7SUFBNUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxDQUFDO21EQUFpQjtBQUpsQyxpQkFBaUI7SUFEN0IsSUFBQSw2QkFBYSxFQUFDLHdCQUF3QixDQUFDO0dBQzNCLGlCQUFpQixDQWlCN0I7QUFqQlksOENBQWlCIn0=